import { satGlobals } from "../../../../../sat/helper/sat-globals";
import axios from 'axios';
import { useResultPageStore } from "../stores/ResultPageStore";
import OutputSelectionManager from "../manager/OutputSelectionManager";
import Analytics from "./Analytics";

let selectedOutputs = [];
let selectedJob = null;
let url = satGlobals.getApiUrl('/api/onedrive-upload');

function getFilenameFromOutput(output) {
    let lastSlashIndex = output.uri.lastIndexOf('/')
    return output.uri.substring(lastSlashIndex + 1)
}

function _getFiles(accessToken) {
    let store = useResultPageStore();

    let payload = [];

    selectedOutputs.forEach((output) => {
        payload.push({
            id: output.id,
            filename: getFilenameFromOutput(output),
        })
    });

    return payload;
}

class OneDrive {

    listener = false;

    constructor() {
    }

    async uploadJob(job) {
        Analytics.send('result_onedrive', 'upload_job', job);

        this._startOneDriveFlow(job.apiJob.id);
    }

    async uploadSelectedOutputs(job) {
        Analytics.send('result_onedrive', 'upload_selected_outputs', job);

        this._startOneDriveFlow(job.apiJob.id);
    }

    async _startOneDriveFlow(id) {
        var options = {
            jobId: id,

        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(options)
        })
            .then(response => response.json())
            .then(data => window.open(data.redirectUrl, '_blank', 'width=900,height=600,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes'))
            .catch(error => console.error('Error:', error));
    }

}

export default new OneDrive()